"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _propTypes2 = require("@agillic/prop-types");
var _progressIndicator = require("./progressIndicator.helper");
var _icon = _interopRequireDefault(require("../icon/icon.presenter"));
var _spinner = _interopRequireDefault(require("../spinner/spinner.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var ProgressIndicator = function ProgressIndicator(_ref) {
  var stages = _ref.stages,
    circleSize = _ref.circleSize;
  return _react.default.createElement("div", {
    className: "progressIndicator"
  }, stages.map(function (_ref2, stageIndex) {
    var state = _ref2.state,
      displayNumber = _ref2.displayNumber,
      displayIcon = _ref2.displayIcon,
      title = _ref2.title,
      uniqueID = _ref2.uniqueID,
      displaySpinner = _ref2.displaySpinner;
    return _react.default.createElement(_react.Fragment, {
      key: uniqueID
    }, _react.default.createElement("div", {
      className: "column"
    }, _react.default.createElement("div", {
      className: "stageCircle ".concat(state),
      "data-testid": uniqueID,
      style: {
        width: circleSize,
        height: circleSize
      }
    }, displaySpinner ? _react.default.createElement(_spinner.default, {
      color: "white",
      size: circleSize / 2,
      thin: "thin"
    }) : displayNumber || _react.default.createElement(_icon.default, {
      name: displayIcon.name
    })), _react.default.createElement("div", {
      className: "title"
    }, title)), stageIndex < stages.length - 1 && _react.default.createElement("div", {
      className: "progressBar ".concat(state),
      style: {
        width: (0, _progressIndicator.calculateWidth)({
          circleSize: circleSize,
          numberOfStages: stages.length
        }),
        height: 5,
        transform: (0, _progressIndicator.calculateTransform)({
          circleSize: circleSize
        })
      }
    }));
  }));
};
ProgressIndicator.propTypes = {
  stages: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    state: _propTypes.string.isRequired,
    title: _propTypes.string.isRequired,
    displayNumber: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _propTypes2.forbiddenBy)('displayIcon')]),
    displayIcon: (0, _airbnbPropTypes.and)([(0, _propTypes.shape)({
      name: _propTypes.string.isRequired,
      namespace: _propTypes.string
    }), (0, _propTypes2.forbiddenBy)('displayNumber')]),
    uniqueID: _propTypes.string
  })).isRequired,
  circleSize: _propTypes.number
};
ProgressIndicator.defaultProps = {
  circleSize: 50
};
var _default = ProgressIndicator;
exports.default = _default;